import styled from 'styled-components'
import { m as motion } from 'framer-motion'
import { Section, Title, Description, SocialLinks } from './globalStyles'
import { media } from './globalStyles'

export const TeamSection = styled(Section)`
  .Scroller {
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    ${media.lessThan('miniTablet')`
      padding: 15rem 5rem 0 5rem;
    `};
    ${media.lessThan('phone')`
      padding: 8rem 1.5625rem 0;
    `};
    & > div:last-child {
      background: ${(props) => props.theme.superLightGray};
    }
  }
`

export const TeamWrapper = styled.div`
  display: grid;
  place-items: center;
  align-content: center;
  height: auto;
  min-height: calc(var(--vh, 1vh) * 100);
  ${media.lessThan('miniTablet')`
    display: block;
  `};
`

export const TeamTitle = styled(Title)`
  text-transform: uppercase;
  text-align: center;
  ${media.lessThan('phone')`
    text-align: left; 
  `};
`

export const TeamDescription = styled(Description)`
  max-width: 66%;
  text-align: center;
  ${media.lessThan('desktop15')`
    max-width: 68%;
  `};
  ${media.lessThan('miniTablet')`
    max-width: none;
  `};
  ${media.lessThan('phone')`
    text-align: left;
  `};
  a {
    font-weight: 500;
    color: ${(props) => props.theme.darkBlue};
    ${media.greaterThan('phone')`
      transition: all 300ms;
      transition-property: color;
      &:hover {
        color: ${(props) => props.theme.white};
      }
    `}
  }
`

export const TeamMembers = styled(motion.div)`
  position: relative;
  width: 60%;
  padding-top: 15%;
  ${media.lessThan('desktop12')`
    width: 70%;
  `}
  ${media.lessThan('tablet')`
    padding: 0;
  `}
  ${media.lessThan('miniTablet')`
    width: 80%;
    margin: 0 auto;
  `}
  ${media.lessThan('phone')`
    width: 100%;
    margin: 0 auto;
  `}
  .TeamWrapper {
    position: absolute;
    left: 50%;
    width: 100%;
    height: 100%;
    bottom: 0;
    transform: translateX(-50%);
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: flex-end;
    margin-top: 5rem;
    ${media.greaterThan('desktop')`
      &:hover {
        & > div {
          opacity: 0;
        }
      }
    `}
    ${media.lessThan('tablet')`
      flex-flow: row wrap;
      position: relative;
      left: auto;
      bottom: auto;
      height: auto;
      transform: none;
      margin-top: 3.5rem;
    `}
  }
`

export const TeamMember = styled(motion.div)`
  position: relative;
  flex: 0 1 20%;
  margin: 0 1.5rem;
  transition: all ease-out;
  transition-duration: 500ms, 300ms;
  transition-property: opacity, flex-basis;
  will-change: opacity, flex-basis;
  h3 {
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translateX(-50%);
    white-space: nowrap;
    font-size: 1.75rem;
    font-weight: 700;
    text-align: center;
    color: black;
    transition: all 300ms linear;
    transition-property: opacity, transform;
    will-change: opacity, transform;
    opacity: 0;
  }
  button {
    position: relative;
    cursor: pointer;
    width: 100%;
    padding-top: 100%;
    border-radius: 50%;
    overflow: hidden;
    transform: translateZ(0);
    will-change: transform;
    -webkit-mask-image: -webkit-radial-gradient(white, black);
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: filter 300ms linear;
      will-change: filter;
      filter: grayscale(1);
    }
  }
  ${media.greaterThan('desktop')`
    &:hover {
      opacity: 1 !important;
      flex-basis: 28%;
      h3 {
        opacity: 1;
        transform: translate(-50%, 1.5rem);
      }
      button {
        img {
          filter: grayscale(0);
        }
      }
    }
  `}
  ${media.lessThan('tablet')`
    flex: 0 1 30%;
    margin: 1.5rem;
  `}
  ${media.lessThan('miniTablet')`
    flex: 0 1 25%;
    margin: 1.5rem;
  `}
  ${media.lessThan('ipad')`
    flex: 0 1 33%;
  `}
  ${media.lessThan('phone')`
    flex: 0 1 40%;
    margin: 0.75rem;
  `}
`

export const TeamModalContainer = styled(Section)`
  position: relative;
  color: white;
  height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
  z-index: 10;
  .Scroller {
    width: 100%;
    height: 100%;
    & > div:last-child {
      background: white;
    }
  }
`

export const TeamModalWrapper = styled(motion.div)`
  width: 100%;
  height: auto;
  min-height: calc(var(--vh, 1vh) * 100);
  padding: 5rem 45% 2.5rem 11.7862%;
  ${media.lessThan('desktop15')`
    padding: 5rem 45% 2.5rem 7.5%;
  `};
  ${media.lessThan('miniTablet')`
    padding: 5rem 45% 2.5rem 3.25rem;
  `};
  ${media.lessThan('phone')`
    padding: 6rem 2.1875rem 2.1875rem;
    display: grid;
    grid-template-columns: 1fr;
    justify-content: center;
    text-align: center;
  `};
`

export const MemberSocialContainer = styled(SocialLinks)`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  margin: 2rem 0 1.5rem;
  ${media.lessThan('phone')`
    margin: 2rem auto 1.5rem;
  `}
  a {
    width: 1.25rem;
    margin-right: 0.75rem;
  }
`

export const TeamModalImage = styled.div`
  position: relative;
  width: 25%;
  padding-top: 25%;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 1rem;
  ${media.lessThan('phone')`
    width: 70%;
    padding-top: 70%;
    margin: 0 auto 1.3rem;
  `};
  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const TeamModalName = styled.h2`
  font-size: 2rem;
  line-height: 2.25rem;
  font-weight: 700;
  color: black;
`

export const TeamModalSubtitle = styled.p`
  font-size: 1.375rem;
  line-height: 1.875rem;
`

export const TeamModalDownload = styled.a`
  font-size: 0.75rem;
  line-height: 0.9375rem;
  font-weight: 400;
  text-transform: uppercase;
  color: black;
  margin-top: 0.75rem;
  ${media.greaterThan('phone')`
    transition: color 300ms linear;
    will-change: color;
    &:hover {
      color: ${props => props.theme.orange};
    }
  `}
`

export const TeamModalBio = styled.div`
  p {
    font-size: 1.5rem;
    line-height: 1.5;
    margin-bottom: 2.5rem;
    &:last-child {
      margin: 0;
    }
  }
`

export const Accent = styled(motion.div)`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vh;
  width: calc(var(--vh, 1vh) * 100);
  padding-top: 100vh;
  padding-top: calc(var(--vh, 1vh) * 100);
  svg {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 50%;
    top: 50%;
    pointer-events: none;
    transform: translate(-50%, -50%);
  }
`